// Mock data for Christ Methodist Church website

export const heroSlides = [
  {
    id: 1,
    image: '/images/home/discover.jpg',
    title: 'Discover',
    subtitle: 'A place of real smiles and genuine joy every Sunday.',
    overlay: 'linear-gradient(to bottom, rgba(30,58,138,0.45) 0%, rgba(37,99,235,0.35) 50%, rgba(30,58,138,0.55) 100%)'
  },
  {
    id: 2,
    image: '/images/home/belong.jpg',
    title: 'Belong',
    subtitle: "You are more than a visitor we're family.",
    overlay: 'linear-gradient(to bottom, rgba(6,95,70,0.45) 0%, rgba(16,185,129,0.35) 50%, rgba(6,95,70,0.55) 100%)'
  },
  {
    id: 3,
    image: '/images/home/connect.jpg',
    title: 'Connect',
    subtitle: 'Find prayer, support, and encouragement for every season.',
    overlay: 'linear-gradient(to bottom, rgba(146,64,14,0.5) 0%, rgba(217,119,6,0.38) 50%, rgba(120,53,15,0.6) 100%)'
  },
  {
    id: 4,
    image: '/images/home/grow.jpg',
    title: 'Grow',
    subtitle: "Grow deeper through prayer, worship, and God's Word.",
    overlay: 'linear-gradient(to bottom, rgba(190,24,93,0.45) 0%, rgba(236,72,153,0.35) 50%, rgba(157,23,77,0.55) 100%)'
  },
  {
    id: 5,
    image: '/images/home/serve.jpg',
    title: 'Serve',
    subtitle: 'Lead with love, share with joy, live as His witness.',
    overlay: 'linear-gradient(to bottom, rgba(185,28,28,0.45) 0%, rgba(220,38,38,0.35) 50%, rgba(153,27,27,0.55) 100%)'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Mr. & Mrs. XXX',
    text: 'CMC has become our spiritual home. The warmth and genuine care we receive here is unmatched. Our children love Sunday School, and we have found true community.',
    role: 'Church Members since 2020'
  },
  {
    id: 2,
    name: 'Mrs. XXX',
    text: 'I came seeking answers and found a family. The prayer support during my difficult time was overwhelming. This church truly lives out Christ\'s love.',
    role: 'Youth Fellowship Leader'
  },
  {
    id: 3,
    name: 'Mr. & Mrs. XXX',
    text: 'After years of searching, we found a church where faith is lived authentically. The worship is heartfelt, the teaching is biblical, and the fellowship is real.',
    role: 'Active Members'
  }
];

export const ministries = [
  {
    id: 1,
    slug: 'sunday-school',
    name: 'Sunday School',
    shortName: 'Sunday School',
    description: 'Nurturing children in faith through engaging Bible stories, worship songs, and activities that build Christian character.',
    image: '/images/assets/swbv7npi.jpg',
    ageGroup: 'Ages 12-18',
    schedule: 'Every Sunday, 9:30 AM',
    leader: 'Mrs. Lanusenla (Eunice) Samuel',
    contactEmail: 'sundayschool@christmethodist.org',
    verse: '"Train up a child in the way he should go, and when he is old he will not depart from it." Proverbs 22:6',
    vision: 'To plant the seeds of faith early so children grow up knowing they are deeply loved by God and called to live for Him.',
    longDescription: 'Sunday School at CMC is a joyful space where children meet Jesus through Scripture, song, and friendship. Our trained teachers walk alongside each child through age-appropriate lessons, creative crafts, memory verses, and meaningful prayer.',
    activities: [
      'Weekly Bible lessons with creative storytelling',
      'Worship songs and Scripture memory',
      'Crafts, games and skits that reinforce God\'s Word',
      'Annual Christmas programme and Vacation Bible School (VBS)',
      'Quarterly parent-teacher meetings'
    ],
    photos: [
      '/images/assets/wu0ijkyb.jpg',
      '/images/assets/p1hv0y5o.jpg',
      '/images/assets/1dov866d.jpg',
      '/images/assets/vqe0gznp.jpg'
    ]
  },
  {
    id: 2,
    slug: 'myf',
    name: 'Methodist Youth Fellowship (MYF)',
    shortName: 'MYF',
    description: 'Empowering young people through discipleship, leadership development, and service opportunities in a vibrant community.',
    image: '/images/assets/8af5bt1c.jpg',
    ageGroup: 'Youth (Ages 13-25)',
    schedule: '4th Sunday (After Service)',
    leader: 'Mr. Daniel Nallapalli',
    contactEmail: 'myf@christmethodist.org',
    verse: '"Don\'t let anyone look down on you because you are young, but set an example for the believers." 1 Timothy 4:12',
    vision: 'A generation of young people anchored in Christ, courageous in faith, and committed to serve their family, church, and city.',
    longDescription: 'MYF is the heartbeat of the next generation at CMC. Through worship, real conversations, mentoring and service, we help students and young adults discover their identity in Christ and their unique calling.',
    activities: [
      'Weekly worship + Bible study nights',
      'Leadership development and discipleship groups',
      'Annual youth camp and retreats',
      'Community service & outreach drives',
      'Sports, music, and creative arts ministry'
    ],
    photos: []
  },
  {
    id: 3,
    slug: 'wscs',
    name: "Women's Society for Christian Service (WSCS)",
    shortName: 'WSCS',
    description: 'Women growing in faith together through Bible study, prayer, fellowship, and community outreach ministry.',
    image: '/images/assets/mi0j6a5x.jpg',
    ageGroup: 'All Women',
    schedule: '3rd Sunday (After Service)',
    leader: 'Mrs. Tina Sudharshan',
    contactEmail: 'wscs@christmethodist.org',
    verse: '"She is clothed with strength and dignity; she can laugh at the days to come." Proverbs 31:25',
    vision: 'Women of faith strengthening one another through prayer, the Word, and selfless service to the church and community.',
    longDescription: 'WSCS is a sisterhood of women mothers, daughters, professionals, homemakers who gather to grow in Christ and care for one another. We pray together, study God\'s Word, and reach out with compassion to those in need.',
    activities: [
      'Monthly fellowship and Bible study',
      'Women\'s prayer cell and intercession',
      'Hospital and home visits',
      'Annual women\'s retreat and conference',
      'Outreach to underprivileged women and children'
    ],
    photos: [
      '/images/assets/mby4c10z.jpg',
      '/images/assets/usrg94qb.jpg',
      '/images/assets/zcrraeiq.jpg',
      '/images/assets/k86u5evy.jpg'
    ]
  },
  {
    id: 4,
    slug: 'mmf',
    name: "Methodist Men's Fellowship (MMF)",
    shortName: 'MMF',
    description: 'Men united in faith, fellowship, and service, supporting one another in spiritual growth and community impact.',
    image: '/images/assets/3w33wjnc.jpg',
    ageGroup: 'All Men',
    schedule: '3rd Sunday (After Service)',
    leader: 'Mr. William Chinnappa',
    contactEmail: 'mmf@christmethodist.org',
    verse: '"As iron sharpens iron, so one man sharpens another." Proverbs 27:17',
    vision: 'Men of integrity who lead their families, serve their church, and influence their communities for Christ.',
    longDescription: 'MMF is a brotherhood that holds each other accountable in faith, family, and work. We meet to study Scripture, pray, share life, and put our hands to service projects that strengthen the church and bless our city.',
    activities: [
      'Monthly fellowship breakfast and Bible study',
      'Men\'s prayer breakfast and accountability groups',
      'Property and maintenance service days',
      'Annual men\'s retreat',
      'Mentoring youth and young men'
    ],
    photos: [
      '/images/assets/g92s531s.jpg',
      '/images/assets/m2hyqovn.jpg',
      '/images/assets/8ybmdkko.jpg',
      '/images/assets/sojfmbmh.jpg'
    ]
  },
  {
    id: 5,
    slug: 'social-concern',
    name: 'Social Concern Ministry',
    shortName: 'Social Concern',
    description: 'Living out Christ\'s compassion through community outreach, support for the needy, and social justice initiatives.',
    image: 'https://images.unsplash.com/photo-1505455184862-554165e5f6ba',
    ageGroup: 'All Members',
    schedule: 'Ongoing'
  }
];

export const events = [
  {
    id: 1,
    title: 'Sunday Worship Service',
    date: '2025-08-17',
    time: '10:00 AM',
    description: 'Join us for heartfelt worship, inspiring message, and Holy Communion.',
    recurring: true
  },
  {
    id: 2,
    title: 'Prayer Meeting',
    date: '2025-08-20',
    time: '7:00 PM',
    description: 'Mid-week prayer gathering to seek God together for our church and community.',
    recurring: true
  },
  {
    id: 3,
    title: 'Family Fellowship Night',
    date: '2025-08-24',
    time: '6:30 PM',
    description: 'A special evening of worship, food, games, and fellowship for the whole family.',
    recurring: false
  }
];

export const resources = [
  {
    id: 1,
    title: 'What We Believe',
    category: 'FAQ',
    content: 'Our core beliefs rooted in Scripture and Methodist tradition.'
  },
  {
    id: 2,
    title: 'New to CMC?',
    category: 'FAQ',
    content: 'Everything you need to know about visiting and joining our church family.'
  },
  {
    id: 3,
    title: 'Growing in Faith',
    category: 'Sermons',
    content: 'Recent sermon series on spiritual growth and discipleship.'
  },
  {
    id: 4,
    title: 'Daily Devotional',
    category: 'Prayers',
    content: 'Start your day with God through our daily prayer guide.'
  }
];

export const churchInfo = {
  name: 'Christ Methodist Church',
  tagline: 'A Family of Faith in North Bangalore',
  address: 'Christ Methodist Church, Kothanur, Bangalore, Karnataka 560077',
  shortAddress: 'Kothanur, North Bangalore',
  email: 'cmckothnur@gmail.com',
  phone: '+91 96327 29007',
  serviceTimes: [
    { day: 'Sunday', time: '9:30 AM', type: 'Worship Service' },
    { day: 'Every Thursday', time: '7:30 PM', type: 'Online Prayer Meeting' },
    { day: 'Monthly · 2nd Friday', time: '7:00 PM – 7:40 PM', type: 'Virtual Bible Study' }
  ],
  mapLocation: 'https://maps.google.com/?q=Christ+Methodist+Church+Kothanur+Bangalore',
  mapEmbed:
    'https://www.google.com/maps?q=Christ%20Methodist%20Church%20Kothanur%20Bangalore&output=embed',
  // YouTube — set ONE of these. youtubeEmbedUrl wins if both are present.
  // For a single video, use: https://www.youtube.com/embed/VIDEO_ID
  // For a channel's latest uploads playlist, use: https://www.youtube.com/embed/videoseries?list=UU<channel-id-without-UC>
  youtubeEmbedUrl: 'https://www.youtube.com/embed/videoseries?list=UU-6ng29nzW70fv5qc2IlsCw',
  youtubeChannelUrl: 'https://www.youtube.com/@cmc_kothanur',
  mission: 'Leading people into a living relationship with Jesus Christ through worship, discipleship, and service.',
  vision: 'A family of faith where all belong, grow, worship, and witness Christ\'s love.',
  values: ['Faith', 'Family', 'Community', 'Worship', 'Service', 'Witness', 'Love', 'Care', 'Fellowship']
};
